import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-721e8022")

_pushScopeId("data-v-721e8022")
const _hoisted_1 = { class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 w-250px`
     }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "text-red-lp-100" }
const _hoisted_4 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = { class: "relative filter-container-client" }
const _hoisted_6 = { class: "text-red-lp-100 text-sm font-semibold md:font-normal md:text-12px absolute top-0 right-0 mt-2 mr-2" }
const _hoisted_7 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_8 = { class: "font-bold text-base lg:font-normal text-gray-lp-300 md:text-12px xxl:text-14px mb-4" }
const _hoisted_9 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_10 = { class: "font-bold text-base lg:font-normal text-gray-lp-300 md:text-12px xxl:text-14px mb-4" }
const _hoisted_11 = { class: "sticky bottom-0" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "absolute w-screen bg-white",
  style: {"bottom":"-20px","margin-left":"-20px","height":"70px","z-index":"-1"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_radio = _resolveComponent("lp-radio")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
        }
      )
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("dashboard.filter")) + " ", 1),
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sumFilter !== 0 ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent('BottomSheet'), {
      title: _ctx.$t('dashboard.filter'),
      class: 
        `select w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md px-4 z-50 overflow-auto`
      ,
      style: {"max-height":"60vh"},
      maxSheetHeight: 70,
      modelValue: _ctx.openFilter,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFilter = $event))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          (_ctx.sumFilter > 0)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                class: "relative cursor-pointer w-full mb-4"
              }, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.reset")), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("dashboard.advanceFilter.serviceType")), 1),
            _createVNode(_component_lp_radio, {
              customClass: "radio-style",
              name: "product",
              options: _ctx.optionProduct,
              labels: _ctx.labelProduct,
              modelValue: _ctx.filterClientDashboard.product,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterClientDashboard.product = $event))
            }, null, 8, ["options", "labels", "modelValue"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("dashboard.advanceFilter.deliveryType")), 1),
            _createVNode(_component_lp_radio, {
              customClass: "radio-style",
              name: "delivery",
              options: _ctx.optionsDeliveryType,
              labels: _ctx.labelDeliveryType,
              modelValue: _ctx.filterData.deliveryType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData.deliveryType = $event)),
              onOnClick: _ctx.setDeliveryType
            }, null, 8, ["options", "labels", "modelValue", "onOnClick"])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_LpButton, {
              isWidthFull: "",
              title: _ctx.$t('dashboard.apply'),
              textColor: "white",
              fontBold: "",
              onClick: _ctx.onChange
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])), [
      [_vShow, _ctx.isMobile ? true : _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
        }
      }
    ]
  ])
})